import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  align-items: center;
  height: 60px;
  padding-left: 16px;
  padding-right: 16px;
  color: var(--card-font-color-secondary);
  font-size: var(--font-size-base);
  border-top: 1px solid var(--border-light-secondary);
  border-bottom: 1px solid var(--border-light-secondary);
}

  @media (min-width: 768px) {:host {
    font-size: var(--font-size-sm)
}
  }

ef-icon {
  margin-right: 6px;
  padding: 6px;
  border-radius: 50%;
  background-color: var(--primary);
  color: var(--contrast-light);
  font-size: 14px;
}

.info-comments {
  margin-left: auto;
}

@media (max-width: 767px) {

.additional-info {
    display: none
}
  }

@media (min-width: 768px) {

.count {
    display: none
}
  }
`;
export default styles;
